import {useEffect, useState} from 'react';

/**
 * Height of the Forge shell chrome above the page: the shell header plus any
 * banner over it. The shell publishes it as `--forge-navbar-height` and
 * registers it as a `<length>` (services/shell/src/styles.css), so its
 * computed value is already in pixels. Standalone the variable is unset and
 * `fallbackPx` is returned.
 *
 * The banner publishes its height as an inline style on <html>, so the value
 * is re-read whenever that style attribute changes.
 */
export function useForgeNavbarHeight(fallbackPx: number): number {
  const [height, setHeight] = useState(() => readForgeNavbarHeight(fallbackPx));

  useEffect(() => {
    const update = () => setHeight(readForgeNavbarHeight(fallbackPx));
    update();
    const observer = new MutationObserver(update);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style'],
    });
    return () => observer.disconnect();
  }, [fallbackPx]);

  return height;
}

function readForgeNavbarHeight(fallbackPx: number): number {
  const height = parseFloat(
    window
      .getComputedStyle(document.documentElement)
      .getPropertyValue('--forge-navbar-height')
  );
  return Number.isNaN(height) ? fallbackPx : height;
}
